const queue = [];

/**
 * 팝업을 큐에 넣습니다.
 * @param target
 * @param priority
 * @param checkChildRemove 자식 노드 제거를 체크할지 유무
 * @param executeCallback
 */
function inQueue(target, priority, checkChildRemove, executeCallback) {
    const queueData = {
        target,
        priority,
        checkChildRemove,
        callback: executeCallback,
    }

    queue.push(queueData);
    queue.sort((a, b) => a.priority - b.priority);
}

/**
 * 맨 앞의 팝업을 추출합니다.
 * @returns {*}
 */
function outQueue() {
    return queue.shift();
}

/**
 * 큐를 복사해 받아옵니다. (깊은 복사로 조작 불가)
 * @returns {*[]}
 */
function getQueueClone() {
    return queue.slice();
}

/**
 * 큐 길이를 가져옵니다.
 * @returns {number}
 */
function getQueueCount() {
    return queue.length;
}

export {inQueue, outQueue, getQueueClone, getQueueCount}